import React from "react";

const CounterOfferModal = ({ isOpen, onClose, onSubmit, amount, setAmount, carTitle, isLoading = false, minAmount }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96 max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-gray-900">Enter Counter Offer</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl"
          >
            ×
          </button>
        </div>
        
        <div className="mb-4 text-left">
          <p className="text-sm text-gray-600 mb-2 text-left">Car: {carTitle}</p>
          <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
            Counter Offer Amount {typeof minAmount === 'number' && !Number.isNaN(minAmount) ? (
              <span className="text-xs text-gray-500">(min {minAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })})</span>
            ) : null}
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-500 sm:text-sm">$</span>
            </div>
            <input
              type="text"
              value={amount}
              onChange={(e) => {
                // Remove any non-numeric characters except decimal point
                const value = e.target.value.replace(/[^0-9.]/g, '');
                setAmount(value);
              }}
              placeholder="Enter amount"
              className="w-full pl-7 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-left"
            />
          </div>
          {(() => {
            const numeric = Number(amount);
            if (!amount || Number.isNaN(numeric)) return null;
            if (typeof minAmount === 'number' && !Number.isNaN(minAmount) && numeric < minAmount) {
              return <p className="text-xs text-red-600 mt-1">Amount must be at least {minAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</p>;
            }
            return null;
          })()}
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            disabled={!amount || isNaN(Number(amount)) || (typeof minAmount === 'number' && !Number.isNaN(Number(amount)) && Number(amount) < minAmount) || isLoading}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center min-w-[140px]"
          >
            {isLoading ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Submitting...
              </>
            ) : (
              "Submit Counter Offer"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CounterOfferModal;
